const TestLogsCardStyles = {
  // CSS animations for expandable row
  animationStyles: `
    @keyframes expandIn {
      from {
        opacity: 0;
        transform: scaleY(0.8) translateY(-10px);
      }
      to {
        opacity: 1;
        transform: scaleY(1) translateY(0);
      }
    }
    
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(15px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes slideInTable {
      from {
        opacity: 0;
        transform: translateY(20px) scale(0.98);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
    
    .expandable-row-content:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .minimalistic-table .ant-table-thead > tr > th {
      background-color: #fafafa !important;
      border-bottom: 1px solid #f0f0f0 !important;
      padding: 8px 12px !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      color: #8c8c8c !important;
      text-transform: uppercase !important;
      letter-spacing: 0.5px !important;
    }
    
    .minimalistic-table .ant-table-thead > tr > th:first-child {
      padding-left: 8px !important;
    }
    
    .minimalistic-table .ant-table-tbody > tr > td {
      padding: 12px 12px !important;
      border-bottom: 1px solid #f5f5f5 !important;
      font-size: 12px !important;
    }
    
    .minimalistic-table .ant-table-tbody > tr > td:first-child {
      padding-left: 8px !important;
    }
    
    .minimalistic-table .ant-table-tbody > tr:hover > td {
      background-color: #fafafa !important;
    }
    
    .minimalistic-table .ant-table-tbody > tr:last-child > td {
      border-bottom: none !important;
    }
    
    .minimalistic-table .ant-table {
      border-radius: 0 !important;
    }
    
    .minimalistic-table .ant-table-container {
      border-radius: 0 !important;
    }
    
    .minimalistic-table .ant-table {
      margin-left: 0 !important;
      padding-left: 0 !important;
    }
    
    .minimalistic-table .ant-table-content {
      margin-left: 0 !important;
      padding-left: 0 !important;
    }
  `,

  // Main card styles
  mainCard: {
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    borderRadius: "12px",
    border: "1px solid #f0f0f0",
  },
  
  mainCardHead: {
    borderBottom: "1px solid #f0f0f0",
    fontSize: "16px",
    fontWeight: 600,
    color: "#262626",
  },

  // No data message styles
  noDataContainer: {
    padding: '20px',
    textAlign: 'center'
  },

  // Expandable row content styles
  expandableRowContent: {
    margin: '8px 0 0 0',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    border: '1px solid #f0f0f0',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    animation: 'expandIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transformOrigin: 'top',
  },

  // Table container styles
  tableContainer: {
    width: '100%'
  },

  // Animation containers
  fadeInUpContainer: {
    animation: 'fadeInUp 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0.2s both'
  },

  slideInTableContainer: {
    animation: 'slideInTable 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.3s both',
    opacity: 0,
    borderRadius: '6px',
    width: 'calc(100%)'
  },

  // Retail ID column styles
  retailIdText: {
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: 'monospace'
  },

  // Metric column styles
  metricText: {
    fontSize: '11px',
    color: '#1890ff'
  },

  // Total column styles
  totalText: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#096dd9'
  },

  // Inner table styles
  innerTable: {
    backgroundColor: '#ffffff',
    marginLeft: '0',
    width: '100%'
  },

  // Main table styles
  mainTable: {
    backgroundColor: "#fafafa",
    borderRadius: "8px",
    overflow: "hidden",
  }
};

export default TestLogsCardStyles;